import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-router-dom'
import { IconPaths, KTSVG, MenuPaths } from '../../../helpers'
import { useAuth } from '../../../../app/modules/auth'
import { useT } from '../../../i18n/Metronici18n'
import { AsideNav, NavSection } from './AsideNav'
import { useMenuPermissoes } from './useMenuPermissoes'

export function AsideMenuMain() {
  const { currentUser, logout } = useAuth()
  const { t } = useT()
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const permissoes = useMenuPermissoes(currentUser)

  const sectionsPaciente: NavSection[] = [
    {
      id: 'atendimentos',
      title: t('menu.atendimentos'),
      entries: [
        {
          kind: 'link',
          id: 'meus-atendimentos',
          to: '/apps/atendimentos/paciente',
          title: t('menu.nav.meus_atendimentos'),
          icon: MenuPaths.Atendimento,
        },
      ],
    },
  ]

  // Grupo SOLICITANTE (LO-1378): só o ciclo da interconsulta e o cadastro de paciente. Esse perfil
  // não tem `Atendimento:*` nem relatórios de gestão no backend.
  const sectionsSolicitante: NavSection[] = [
    {
      id: 'interconsulta',
      title: t('menu.nav.interconsulta'),
      entries: [
        {
          kind: 'group',
          id: 'pareceres',
          title: t('menu.pareceres'),
          icon: MenuPaths.Avaliacoes,
          items: [
            { to: '/apps/pareceres', title: t('menu.nav.interconsulta_minhas') },
            { to: '/apps/pareceres/equipe', title: t('menu.nav.interconsulta_equipe') },
          ],
        },
        {
          kind: 'link',
          id: 'pacientes',
          to: '/apps/pacientes-management/pacientes',
          title: t('menu.pacientes'),
          icon: MenuPaths.Pacientes,
        },
      ],
    },
  ]

  const sections: NavSection[] = [
    {
      id: 'operacao',
      title: t('menu.nav.secao_operacao'),
      entries: [
        {
          kind: 'link',
          id: 'inicio',
          to: '/',
          title: t('menu.nav.inicio'),
          icon: MenuPaths.Inicio,
        },
        {
          kind: 'group',
          id: 'atendimento',
          title: t('menu.nav.atendimento'),
          icon: MenuPaths.Atendimento,
          items: [
            // Agenda oculta no menu por ora (ver 0e658235b); a rota continua ativa.
            // { to: '/agenda', title: t('menu.agenda'), visible: permissoes.agenda },
            { to: '/apps/escalas', title: t('menu.escalas'), visible: permissoes.escalas },
            { to: '/apps/atendimentosMedicos/lista', title: t('menu.atendimentos_lista') },
            {
              to: '/apps/meus-atendimentos/lista',
              title: t('menu.nav.meus_atendimentos'),
              visible: permissoes.meusAtendimentos,
            },
            { to: '/apps/sncr/lista', title: t('menu.sncr'), visible: permissoes.sncr },
            {
              to: '/apps/protocolos-triagem',
              title: t('menu.protocolos_triagem'),
              visible: permissoes.protocolosTriagem,
            },
            {
              to: '/apps/atendimentosMedicos/gestao',
              title: t('menu.nav.gestao_atendimentos'),
              visible: permissoes.atendimentosGestao,
            },
            {
              to: '/apps/importacao/lista',
              title: t('menu.atendimentos_importar'),
              visible: permissoes.importar,
            },
            {
              to: '/apps/monitoramento',
              title: t('menu.monitoramento'),
              visible: permissoes.monitoramento,
            },
          ],
        },
        {
          kind: 'group',
          id: 'avaliacoes',
          title: t('menu.avaliacoes'),
          icon: MenuPaths.Avaliacoes,
          items: [
            {
              to: '/apps/avaliacoes/pendentes/lista',
              title: t('menu.nav.avaliacoes_pendentes'),
              visible: permissoes.avaliacoesPendentes,
            },
            {
              to: '/apps/avaliacoes/lista',
              title: t('menu.nav.avaliacoes_todas'),
              visible: permissoes.avaliacoes,
            },
            { to: '/apps/pareceres', title: t('menu.pareceres'), visible: permissoes.pareceres },
            {
              // Do solicitante (menu próprio) e do SUPER_ADMIN; médico não vê a equipe.
              to: '/apps/pareceres/equipe',
              title: t('menu.nav.interconsulta_equipe'),
              visible: permissoes.superAdmin,
            },
          ],
        },
        {
          kind: 'link',
          id: 'pacientes',
          to: '/apps/pacientes-management/pacientes',
          title: t('menu.pacientes'),
          icon: MenuPaths.Pacientes,
          visible: permissoes.pacientes,
        },
        {
          kind: 'group',
          id: 'saude-ocupacional',
          title: t('menu.nav.saude_ocupacional'),
          icon: MenuPaths.Saude_Ocupacional,
          items: [
            {
              to: '/apps/atendimentosAso/assinar',
              title: t('menu.nav.aso_assinar'),
              visible: permissoes.assinarAso,
            },
            {
              to: '/apps/atendimentosAso/gerar',
              title: t('menu.nav.aso_gerar'),
              visible: permissoes.assinarAso,
            },
            {
              to: '/apps/downloadAso/download',
              title: t('menu.nav.aso_baixar'),
              visible: permissoes.downloadAso,
            },
            {
              to: '/apps/empresasCliente/lista',
              title: t('menu.nav.aso_empregadores'),
              visible: permissoes.empresaCliente,
            },
          ],
        },
        {
          kind: 'group',
          id: 'financeiro',
          title: t('menu.nav.financeiro'),
          icon: MenuPaths.Financeiro,
          items: permissoes.portalTransparencia
            ? [
                {
                  to: '/financeiro/atendimentos',
                  title: t('menu.nav.nao_faturados'),
                  visible: permissoes.atendimentosNaoFaturados,
                },
                {
                  to: '/financeiro/faturas',
                  title: t('menu.faturas'),
                  visible: permissoes.faturas,
                },
                {
                  to: '/financeiro/faturas/responsavel',
                  title: t('menu.faturas'),
                  visible: permissoes.faturasResponsavel,
                },
                {
                  to: '/financeiro/faturas/profissional',
                  title: t('menu.nav.minhas_faturas'),
                  visible: permissoes.faturasProfissional,
                },
                {
                  to:
                    permissoes.isMedico && !permissoes.isFinanceiro
                      ? '/financeiro/notas/profissional'
                      : '/financeiro/notas',
                  title: t('menu.notas'),
                  visible: permissoes.notas,
                },
              ]
            : [],
        },
        {
          kind: 'group',
          id: 'relatorios',
          title: t('menu.relatorios'),
          icon: MenuPaths.Relatorios,
          items: [
            {
              to: '/apps/indicadores',
              title: t('menu.indicadores'),
              visible: permissoes.indicadores,
            },
            {
              to: '/apps/relatorios-interconsulta',
              title: t('menu.relatorios_interconsulta'),
              visible: permissoes.indicadores,
            },
            {
              to: '/apps/relatorios/atendimentos',
              title: t('menu.nav.relatorio_atendimentos'),
              visible: permissoes.relatorios,
            },
            {
              to: '/apps/relatorio-nps',
              title: t('menu.relatorios_nps'),
              visible: permissoes.relatorioNps,
            },
          ],
        },
      ],
    },
    {
      id: 'configuracao',
      title: t('menu.nav.secao_configuracao'),
      entries: [
        {
          kind: 'group',
          id: 'cadastros',
          title: t('menu.nav.cadastros'),
          icon: MenuPaths.Cadastros,
          items: [
            {
              to: '/apps/empresas',
              title: t('menu.nav.instituicao'),
              visible: permissoes.empresa,
            },
            {
              to: '/apps/empresas/clientes',
              title: t('menu.nav.entidades'),
              visible: permissoes.clienteContratos,
            },
            {
              to: '/apps/unidades',
              title: t('menu.nav.unidades_setores'),
              visible: permissoes.unidades,
            },
            {
              to: '/apps/funcionarios',
              title: t('menu.funcionarios'),
              visible: permissoes.funcionarios,
            },
            {
              to: '/apps/especialidades',
              title: t('menu.especialidades'),
              visible: permissoes.especialidades,
            },
            {
              to: '/apps/formularios',
              title: t('menu.formularios'),
              visible: permissoes.formularios,
            },
          ],
        },
        {
          kind: 'link',
          id: 'esus',
          to: '/apps/esus/lista',
          title: t('menu.nav.esus_envios'),
          icon: MenuPaths.Esus,
          visible: permissoes.esusEnvios,
        },
      ],
    },
    {
      // Tudo o que é exclusivo de SUPER_ADMIN (permissoes.superAdmin / permissoes.api).
      id: 'super-admin',
      title: t('menu.nav.secao_super_admin'),
      visible: permissoes.superAdmin,
      entries: [
        {
          kind: 'group',
          id: 'cadastros-globais',
          title: t('menu.nav.cadastros_globais'),
          icon: MenuPaths.Cadastros_Globais,
          items: [
            { to: '/apps/admin/profissionais-saude', title: t('menu.nav.profissionais_saude') },
            { to: '/apps/admin/exames', title: t('menu.exames') },
            { to: '/apps/admin/medicamentos', title: t('menu.medicamentos') },
            { to: '/apps/admin/modelos', title: t('menu.modelos') },
            { to: '/apps/admin/termos', title: t('menu.nav.termos') },
            { to: '/apps/admin/notas-versao', title: t('menu.nav.notas_versao') },
            { to: '/apps/admin/telekits', title: t('menu.telekits') },
            { to: '/apps/admin/dispositivos', title: t('menu.dispositivos') },
            { to: '/apps/admin/fornecedores', title: t('menu.fornecedores') },
          ],
        },
        {
          kind: 'group',
          id: 'acesso-auditoria',
          title: t('menu.nav.acesso_auditoria'),
          icon: MenuPaths.Administracao,
          items: [
            { to: '/apps/admin/usuarios', title: t('menu.usuarios') },
            { to: '/apps/admin/grupos', title: t('menu.nav.perfis_acesso') },
            { to: '/apps/admin/parametros', title: t('menu.nav.parametros') },
            { to: '/apps/admin/logs/consulta', title: t('menu.nav.logs_consulta') },
            { to: '/apps/admin/logs/usuario', title: t('menu.nav.logs_usuario') },
            { to: '/apps/admin/exportar', title: t('menu.nav.exportar_auditoria') },
            { to: '/apps/notificacoes/enviadas', title: t('menu.notificacoes_enviadas') },
          ],
        },
        {
          kind: 'link',
          id: 'api',
          to: '/apps/api',
          title: t('menu.api'),
          icon: MenuPaths.Api,
          visible: permissoes.api,
        },
      ],
    },
  ]

  if (!currentUser) {
    return null
  }

  return (
    <>
      <AsideNav
        sections={
          permissoes.paciente
            ? sectionsPaciente
            : permissoes.solicitante
            ? sectionsSolicitante
            : sections
        }
      />

      {isMobile && (
        <div className='lz-nav-section'>
          {/* No mobile o menu do cabeçalho some: Novidades fica junto do Sair. */}
          <Link to='/apps/novidades' className='lz-nav-link'>
            <KTSVG path={IconPaths.Info} className='lz-nav-icon' />
            <span className='lz-nav-label'>{t('menu.novidades')}</span>
          </Link>
          <button type='button' className='lz-nav-link' onClick={logout}>
            <KTSVG path={MenuPaths.Sair} className='lz-nav-icon' />
            <span className='lz-nav-label'>{t('common.exit')}</span>
          </button>
        </div>
      )}
    </>
  )
}
